import React from "react";

const DetailsCerita = () => {
  return (
    <div className="ceritaUser-container">
      <h1>Cerita UMKM</h1>

      <h3>Matthew Thomas</h3>
      <h5>24 Juni 2022</h5>
      <hr />

      <p>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure aliquid
        architecto laboriosam vero tempore asperiores aliquam doloremque quam
        dignissimos id aut, ea, odit temporibus eos repellat at commodi
        voluptatem labore. Lorem ipsum, dolor sit amet consectetur adipisicing
        elit. Debitis ex excepturi, exercitationem nihil explicabo laborum
        accusamus repellat, et voluptatibus atque nisi deleniti ea cumque soluta
        odit minus alias nobis perferendis. Lorem ipsum dolor sit amet
        consectetur, adipisicing elit. Iure aliquid architecto laboriosam vero
        tempore asperiores aliquam doloremque quam dignissimos id aut, ea, odit
        temporibus eos repellat at commodi voluptatem labore. Lorem ipsum, dolor
        sit amet consectetur adipisicing elit. Debitis ex excepturi,
        exercitationem nihil explicabo laborum accusamus repellat, et
        voluptatibus atque nisi deleniti ea cumque soluta odit minus alias nobis
        perferendis. Lorem ipsum dolor sit amet consectetur, adipisicing elit.
        Iure aliquid architecto laboriosam vero tempore asperiores aliquam
        doloremque quam dignissimos id aut, ea, odit temporibus eos repellat at
        commodi voluptatem labore. Lorem ipsum, dolor sit amet consectetur
        adipisicing elit. Debitis ex excepturi, exercitationem nihil explicabo
        laborum accusamus repellat, et voluptatibus atque nisi deleniti ea
        cumque soluta odit minus alias nobis perferendis. Lorem ipsum dolor sit
        amet consectetur, adipisicing elit. Iure aliquid architecto laboriosam
        vero tempore asperiores aliquam doloremque quam dignissimos id aut, ea,
        odit temporibus eos repellat at commodi voluptatem labore. Lorem ipsum,
        dolor sit amet consectetur adipisicing elit. Debitis ex excepturi,
        exercitationem nihil explicabo laborum accusamus repellat, et
        voluptatibus atque nisi deleniti ea cumque soluta odit minus alias nobis
        perferendis.
      </p>
    </div>
  );
};

export default DetailsCerita;
